(function() {
  'use strict';

  var POPUP_COOKIES = {
    SUBSCRIBED: 'np_subscribed',
    CLOSED: 'np_closed',
    BADGE_CLOSED: 'np_badge_closed'
  };

  function CookieManager(days) {
    this.days = days || 30;
  }

  CookieManager.prototype.set = function(name, value, days) {
    var expires = '';
    var d = days || this.days;
    var date = new Date();
    date.setTime(date.getTime() + d * 86400000);
    expires = '; expires=' + date.toUTCString();
    document.cookie = name + '=' + (value || '1') + expires + '; path=/';
  };

  CookieManager.prototype.get = function(name) {
    var nameEQ = name + '=';
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
      if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length);
    }
    return null;
  };

  CookieManager.prototype.remove = function(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  };

  function NewsletterPopup() {
    this.popup = null;
    this.badge = null;
    this.form = null;
    this.cookie = new CookieManager(30);
    this.config = {};
    this.isSubscribed = false;
    this.isClosed = false;
    this.isBadgeClosed = false;
    this.triggerTimer = null;
    this.scrollHandler = null;
  }

  NewsletterPopup.prototype.init = function() {
    this.popup = document.querySelector('.m-newsletter-popup');
    if (!this.popup) return;

    this.badge = document.getElementById('NewsletterPopupBadge');
    this.form = this.popup.querySelector('.m-newsletter-popup__form');
    
    this.config = {
      enable: this.popup.getAttribute('data-enable') === 'true',
      designMode: this.popup.getAttribute('data-design-mode') === 'true',
      triggerType: this.popup.getAttribute('data-trigger-type') || 'delay',
      delayTime: parseInt(this.popup.getAttribute('data-delay-time')) || 5,
      scrollPercentage: parseInt(this.popup.getAttribute('data-scroll-percentage')) || 50,
      cookieDays: parseInt(this.popup.getAttribute('data-cookie-days')) || 30,
      successMessage: this.popup.getAttribute('data-success-message') || 'Thanks for subscribing!',
      badgeEnable: this.badge && this.badge.getAttribute('data-badge-enable') === 'true'
    };

    this.cookie = new CookieManager(this.config.cookieDays);
    
    this.isSubscribed = !!this.cookie.get(POPUP_COOKIES.SUBSCRIBED);
    this.isClosed = !!this.cookie.get(POPUP_COOKIES.CLOSED);
    this.isBadgeClosed = !!this.cookie.get(POPUP_COOKIES.BADGE_CLOSED);

    var isHome = this._isHomePage();

    if (this.config.designMode) {
      this._bindEvents();
      this.show();
      return;
    }

    if (!this.config.enable || !isHome) return;
    if (this.isSubscribed) return;

    this._bindEvents();

    if (this.isClosed) {
      this._showBadge();
      return;
    }

    this._setupTrigger();
  };

  NewsletterPopup.prototype._isHomePage = function() {
    if (typeof Shopify !== 'undefined' && Shopify.template === 'index') return true;
    var path = location.pathname;
    return path === '/' || path === '/index.html';
  };

  NewsletterPopup.prototype._setupTrigger = function() {
    var self = this;
    var type = this.config.triggerType;

    if (type === 'immediate') {
      this.show();
      return;
    }

    if (type === 'delay') {
      this.triggerTimer = setTimeout(function() {
        self.show();
      }, this.config.delayTime * 1000);
      return;
    }

    if (type === 'scroll') {
      this._setupScrollTrigger();
    }
  };

  NewsletterPopup.prototype._setupScrollTrigger = function() {
    var self = this;
    var targetPercent = this.config.scrollPercentage;

    this.scrollHandler = function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      if (scrollPercent >= targetPercent) {
        self.show();
        window.removeEventListener('scroll', self.scrollHandler);
      }
    };

    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  };

  NewsletterPopup.prototype._bindEvents = function() {
    var self = this;

    this.popup.querySelectorAll('[data-popup-close]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        self.close();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.popup.classList.contains('is-active')) {
        self.close();
      }
    });

    if (this.badge) {
      this._bindBadgeEvents();
    }

    if (this.form) {
      this.form.addEventListener('submit', function(e) {
        e.preventDefault();
        self._handleSubmit();
      });
    }
  };

  NewsletterPopup.prototype._bindBadgeEvents = function() {
    var self = this;

    this.badge.addEventListener('click', function(e) {
      var closeBtn = e.target.closest('.m-newsletter-popup__badge-close');
      if (closeBtn) {
        e.stopPropagation();
        self.cookie.set(POPUP_COOKIES.BADGE_CLOSED);
        self.isBadgeClosed = true;
        self.badge.classList.remove('is-visible');
        return;
      }
      self.show();
    });
  };

  NewsletterPopup.prototype.show = function() {
    if (this.isSubscribed) return;
    
    if (this.triggerTimer) {
      clearTimeout(this.triggerTimer);
      this.triggerTimer = null;
    }

    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }

    this.popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  };

  NewsletterPopup.prototype.hide = function() {
    this.popup.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  NewsletterPopup.prototype.close = function() {
    this.hide();
    this.cookie.set(POPUP_COOKIES.CLOSED);

    if (!this.isSubscribed && this.config.badgeEnable) {
      this._showBadge();
    }
  };

  NewsletterPopup.prototype._showBadge = function() {
    if (!this.badge || this.isSubscribed) return;
    if (this.isBadgeClosed) return;
    if (!this.config.badgeEnable) return;
    
    setTimeout(function() {
      this.badge.classList.add('is-visible');
    }.bind(this), 300);
  };

  NewsletterPopup.prototype._hideBadge = function() {
    if (this.badge) {
      this.badge.classList.remove('is-visible');
    }
  };

  NewsletterPopup.prototype._handleSubmit = function() {
    var emailInput = this.form.querySelector('input[type="email"]');
    var email = emailInput.value.trim();

    if (!email || !this._isValidEmail(email)) {
      this._showMessage('Please enter a valid email address.', 'error');
      return;
    }

    var self = this;
    this._setLoading(true);
    this._hideMessage();

    var iframeName = 'newsletter_iframe_' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.cssText = 'display:none;';
    document.body.appendChild(iframe);

    var form = this.form;
    var originalTarget = form.target;
    form.target = iframeName;
    form.submit();

    var isDone = false;
    var restoreTarget = function() {
      form.target = originalTarget;
    };

    var finish = function() {
      if (isDone) return;
      isDone = true;
      clearInterval(checkInterval);
      restoreTarget();
      self._setLoading(false);
      self._onSuccess();
      setTimeout(function() {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 1000);
    };

    var checkInterval = setInterval(function() {
      if (isDone) return;
      try {
        var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc && iframeDoc.body && iframeDoc.body.innerHTML.length > 0) {
          finish();
        }
      } catch(e) {
        finish();
      }
    }, 200);

    setTimeout(function() {
      finish();
    }, 5000);
  };

  NewsletterPopup.prototype._onSuccess = function() {
    this.isSubscribed = true;
    this.cookie.set(POPUP_COOKIES.SUBSCRIBED);
    this._showSuccessUI();
    this._hideBadge();
  };

  NewsletterPopup.prototype._showSuccessUI = function() {
    var self = this;
    var content = this.popup.querySelector('.m-newsletter-popup__content');
    if (!content) return;

    var elements = content.querySelectorAll(
      '.m-newsletter-popup__title, ' +
      '.m-newsletter-popup__subtitle, ' +
      '.m-newsletter-popup__form-wrapper'
    );
    elements.forEach(function(el) {
      el.style.display = 'none';
    });

    var success = document.createElement('div');
    success.className = 'm-newsletter-popup__success';
    success.innerHTML =
      '<span class="m-newsletter-popup__success-icon">&#10003;</span>' +
      '<h2 class="m-newsletter-popup__success-title">You\'re Subscribed!</h2>' +
      '<p class="m-newsletter-popup__success-text">' +
        this._escapeHtml(this.config.successMessage) +
      '</p>' +
      '<button type="button" class="m-newsletter-popup__success-close">Close</button>';

    content.appendChild(success);

    success.querySelector('.m-newsletter-popup__success-close').addEventListener('click', function() {
      self.close();
    });
  };

  NewsletterPopup.prototype._showMessage = function(text, type) {
    var msg = this.popup.querySelector('.m-newsletter-popup__message');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'm-newsletter-popup__message';
      this.form.insertBefore(msg, this.form.firstChild);
    }
    msg.className = 'm-newsletter-popup__message m-newsletter-popup__message--' + type;
    msg.textContent = text;
    msg.style.display = 'block';
  };

  NewsletterPopup.prototype._hideMessage = function() {
    var msg = this.popup.querySelector('.m-newsletter-popup__message');
    if (msg) {
      msg.style.display = 'none';
    }
  };

  NewsletterPopup.prototype._setLoading = function(isLoading) {
    var button = this.popup.querySelector('.m-newsletter-popup__button');
    if (!button) return;

    if (isLoading) {
      this.form.classList.add('is-loading');
      button.classList.add('is-loading');
      button.disabled = true;
      var originalText = button.textContent.trim();
      button.dataset.originalText = originalText;
      button.innerHTML = '<span class="np-spinner"></span>' + originalText;
    } else {
      this.form.classList.remove('is-loading');
      button.classList.remove('is-loading');
      button.disabled = false;
      if (button.dataset.originalText) {
        button.textContent = button.dataset.originalText;
      }
    }
  };

  NewsletterPopup.prototype._isValidEmail = function(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  NewsletterPopup.prototype._escapeHtml = function(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      var popup = new NewsletterPopup();
      popup.init();
    });
  } else {
    var popup = new NewsletterPopup();
    popup.init();
  }
})();